import { FormlyFieldConfig } from '@ngx-formly/core';

export function rawValidationMessageHandler(error: any, field: FormlyFieldConfig): any {
  return error;
}
